// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import QUERY_TYPES from './types';
import useApiRequest from '../useRequest';

// Common invalidate queries.
const commonInvalidateQueries = (queryClient) => {
  queryClient.invalidateQueries(QUERY_TYPES.WITHHOLDING_TAX_RATES);
};

/**
 * Retrieves tax rates.
 * @param {number} customerId - Customer id.
 */
export function useWithholdingTaxRates(props) {
  return useRequestQuery(
    [QUERY_TYPES.WITHHOLDING_TAX_RATES],
    {
      method: 'get',
      url: `withholding-tax-rates`,
    },
    {
      select: (res) => res.data.data,
      defaultData: [],
      ...props,
    },
  );
}

/**
 * Retrieves tax rate.
 * @param {number} taxRateId - Tax rate id.
 */
export function useWitholdingTaxRate(taxRateId: string, props) {
  return useRequestQuery(
    [QUERY_TYPES.WITHHOLDING_TAX_RATES, taxRateId],
    {
      method: 'get',
      url: `withholding-tax-rates/${taxRateId}}`,
    },
    {
      select: (res) => res.data.data,
      ...props,
    },
  );
}

/**
 * Edit the given tax rate.
 */
export function useEditWitholdingTaxRate(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([id, values]) => apiRequest.post(`withholding-tax-rates/${id}`, values),
    {
      onSuccess: (res, id) => {
        commonInvalidateQueries(queryClient);
        queryClient.invalidateQueries([QUERY_TYPES.WITHHOLDING_TAX_RATES, id]);
        queryClient.invalidateQueries(QUERY_TYPES.ITEM);
        queryClient.invalidateQueries(QUERY_TYPES.ITEMS);
      },
      ...props,
    },
  );
}

/**
 * Creates a new tax rate.
 */
export function useCreateWitholdingTaxRate(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('withholding-tax-rates', values), {
    onSuccess: (res, id) => {
      commonInvalidateQueries(queryClient);
      queryClient.invalidateQueries([QUERY_TYPES.WITHHOLDING_TAX_RATES, id]);
    },
    ...props,
  });
}

/**
 * Delete the given tax rate.
 */
export function useDeleteWitholdingTaxRate(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.delete(`withholding-tax-rates/${id}`), {
    onSuccess: (res, id) => {
      commonInvalidateQueries(queryClient);
      queryClient.invalidateQueries([QUERY_TYPES.WITHHOLDING_TAX_RATES, id]);
    },
    ...props,
  });
}

/**
 * Activate the given tax rate.
 */
export function useActivateWitholdingTaxRate(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.post(`withholding-tax-rates/${id}/active`), {
    onSuccess: (res, id) => {
      commonInvalidateQueries(queryClient);
      queryClient.invalidateQueries([QUERY_TYPES.WITHHOLDING_TAX_RATES, id]);
    },
    ...props,
  });
}

/**
 * Inactivate the given tax rate.
 */
export function useInactivateWitholdingTaxRate(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.post(`withholding-tax-rates/${id}/inactive`), {
    onSuccess: (res, id) => {
      commonInvalidateQueries(queryClient);
      queryClient.invalidateQueries([QUERY_TYPES.WITHHOLDING_TAX_RATES, id]);
    },
    ...props,
  });
}
